import {
  createAuthMutationHook,
  createBasicMutationHook,
  createQueryHook,
  createSubscriptionDataHook,
  createSubscriptionHook,
} from "../factory";

const userKeys = {
  all: ["users"] as const,
  details: () => [...userKeys.all, "detail"] as const,
};

export const auth = {
  getUser: createQueryHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auth.getUser,
    queryKeyFn: userKeys.details,
  }),
  login: createAuthMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auth.login,
    mutationKey: ["auth", "login"],
  }),
  loginChallenge: createAuthMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auth.loginChallenge,
    mutationKey: ["auth", "loginChallenge"],
  }),
  forceChangePassword: createAuthMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auth.forceChangePassword,
    mutationKey: ["auth", "forceChangePassword"],
  }),
  forgotPassword: createBasicMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auth.forgotPassword,
    mutationKey: ["auth", "forgotPassword"],
  }),
  logout: createBasicMutationHook({
    methodSelector: (alaffiaClient) => alaffiaClient.auth.logout,
    mutationKey: ["auth", "logout"],
  }),
  userId: createSubscriptionDataHook({
    observableSelector: (alaffiaClient) => alaffiaClient.auth.loginStatus,
    transformResult: (result) => {
      if (result.data?.type === "LoginSuccessResult") {
        return result.data.userId;
      }
      return null;
    },
  }),
  loggedIn: createSubscriptionDataHook({
    observableSelector: (alaffiaClient) => alaffiaClient.auth.loginStatus,
    transformResult: (result) => result.loggedIn,
  }),
  loginStatus: createSubscriptionHook({
    observableSelector: (alaffiaClient) => alaffiaClient.auth.loginStatus,
  }),
};
